import { Icons } from '@commenda/kakashi';

export const ChatMessagesNavigationControls = ({
  goToPreviousSearchResult,
  goToNextSearchResult,
  searchMatches,
  currentSearchIndex,
}: {
  goToPreviousSearchResult: () => void;
  goToNextSearchResult: () => void;
  searchMatches: { messageId: string; matchIndex: number }[];
  currentSearchIndex: number;
}) => {
  return (
    <div className="absolute bottom-28 left-1/2 transform -translate-x-1/2 pointer-events-none z-10">
      <div className="pointer-events-auto flex items-center divide-x rounded-md bg-bg-primary shadow-lg border border-border-primary overflow-clip">
        {searchMatches.length > 0 && (
          <button
            type="button"
            onClick={goToPreviousSearchResult}
            disabled={searchMatches.length === 0 || currentSearchIndex === 0}
            className="h-8 w-8 flex items-center justify-center hover:bg-bg-secondary disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label="Previous search result"
          >
            <Icons.ChevronUp className="size-4" />
          </button>
        )}

        <span className="text-text-primary h-8 flex items-center txt-small-medium px-md select-none">
          {searchMatches.length > 0
            ? `${currentSearchIndex + 1} of ${searchMatches.length}`
            : 'No matches'}
        </span>

        {searchMatches.length > 0 && (
          <button
            type="button"
            onClick={goToNextSearchResult}
            disabled={
              searchMatches.length === 0 ||
              currentSearchIndex === searchMatches.length - 1
            }
            className="h-8 w-8 flex items-center justify-center hover:bg-bg-secondary disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label="Next search result"
          >
            <Icons.ChevronDown className="size-4" />
          </button>
        )}
      </div>
    </div>
  );
};
